import type { ListBuilderConfiguration } from '../../types';
import { allLocationsList } from './lists/all-locations';

/**
 * Location list configuration.
 * The legacy merchandiser-as-location views (All / Inactive / Maintenance /
 * Low Stock / High Temp Merchandisers) were removed — merchandisers are their
 * own entity now (/distribution/merchandisers); those views are reborn as tabs
 * on the merchandiser list.
 */
export const LOCATION_LIST_CONFIG: ListBuilderConfiguration = {
	lists: [allLocationsList],
	paging: {
		defaultPageSize: 25,
		pageSizeOptions: [25, 50, 100],
	},
	filters: {
		activeFilters: ['locationType', 'locationStatus', 'stockLevel', 'highTemp'],
		filterContexts: {
			locationType: {
				hideInContexts: ['warehouses'],
			},
		},
		defaultFilters: {},
	},
	objects: [
		{
			baseUrl: '/locations/:id',
			objectLabel: 'Location',
			objectTable: 'location',
			selectedFields: [
				{ fieldName: '_id', fieldLabel: 'ID' },
				{ fieldName: 'code', fieldLabel: 'Code' },
				{ fieldName: 'description', fieldLabel: 'Description' },
				{ fieldName: 'type', fieldLabel: 'Type' },
				{ fieldName: 'locationCode', fieldLabel: 'Location Code' },
				{ fieldName: 'capacity', fieldLabel: 'Capacity' },
				{ fieldName: 'units', fieldLabel: 'Units' },
				{ fieldName: 'status', fieldLabel: 'Status' },
				{ fieldName: 'warehouseId', fieldLabel: 'Warehouse ID' },
				{ fieldName: '_created_date', fieldLabel: 'Created Date' },
			],
		},
	],
	tableSorts: [
		{
			id: 'code',
			name: 'Code',
			fields: [
				{
					direction: 'ASC',
					fieldName: 'code',
					objectTable: 'location',
				},
			],
			description: 'Sort locations by code',
		},
		{
			id: 'type',
			name: 'By Type',
			fields: [
				{
					direction: 'ASC',
					fieldName: 'type',
					objectTable: 'location',
				},
				{
					direction: 'ASC',
					fieldName: 'code',
					objectTable: 'location',
				},
			],
			description: 'Sort by location type then code',
		},
		{
			id: 'capacity',
			name: 'By Capacity',
			fields: [
				{
					direction: 'DESC',
					fieldName: 'capacity',
					objectTable: 'location',
				},
			],
			description: 'Sort by capacity (highest first)',
		},
		{
			id: 'status',
			name: 'By Status',
			fields: [
				{
					direction: 'ASC',
					fieldName: 'status',
					objectTable: 'location',
				},
				{
					direction: 'ASC',
					fieldName: 'code',
					objectTable: 'location',
				},
			],
			description: 'Sort by status then code',
		},
	],
};
